'use strict';

exports.__esModule = true;
exports.getMatchMedia = getMatchMedia;
exports.releaseMatchMedia = releaseMatchMedia;

var _mq = require('../mq/mq.json');

var _mq2 = _interopRequireDefault(_mq);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var pool = {};
var refCounters = {};
/**
 * Возвращает MediaQueryList для заданного media-выражения.
 *
 * @param {String} queryProp media выражение или кастомные запросы из `src/mq/mq.json`, например `--small`.
 * @returns {MediaQueryList}
 */

function getMatchMedia(queryProp) {
  var query = _mq2.default[queryProp] || queryProp;

  if (!pool[query]) {
    pool[query] = window.matchMedia(query);
    refCounters[query] = 1;
  } else {
    refCounters[query] += 1;
  }

  return pool[query];
}
/**
 * Удаляет MediaQueryList.
 *
 * @param {String} queryProp media выражение
 */


function releaseMatchMedia(queryProp) {
  var query = _mq2.default[queryProp] || queryProp;
  refCounters[query] -= 1;

  if (pool[query] && refCounters[query] === 0) {
    delete pool[query];
    delete refCounters[query];
  }
}